module.exports = __webpack_public_path__ + "static/media/_prn.4e55deb7.svg";